import { PrismicNextImage } from "@prismicio/next";

/**
 * @typedef {import("@prismicio/client").Content.BlogSliceImagePrimary} ImagePrimary
 * @param {{ primary: ImagePrimary }} props
 */
const Image = ({ primary }) => (
  <div className="flex flex-col gap-5">
    <PrismicNextImage field={primary.image} className="w-full object-cover" />
    <p className="p-sm-n lt text-bleu-90 text-center italic">{primary.note}</p>
  </div>
);

export default Image;
